import { http } from '@/utils'

export const workFlowTreeApi = (data: any): any => http.post(`/workflow/apply/projects/tree`, data)
